// extracted by mini-css-extract-plugin
var _1 = "FileBox-module_btn_file__g15hUs";
var _2 = "FileBox-module_btn_file_label__Y_y9gl";
var _3 = "FileBox-module_input_file__A4bRcf";
export { _1 as "btn_file", _2 as "btn_file_label", _3 as "input_file" }
